<template>
  <footer>
    <div
      id="footer-pre"
      class="container-fluid"
    />

    <b-container>
      <b-row>
        <b-col md="3">
          <p class="text-muted text-center">
            EUKOAL is coordinated by <a href="https://giz.berlin"> GIZ
          </a>
            <a href="https://giz.berlin">
              <img
                  class="text-center mt-3"
                  src="../assets/images/giz.svg"
                  height="150px"
              >
            </a>
          </p>
        </b-col>
        <b-col md="3">
          <p class="mt-5 text-center">
            <a href="https://bmbf.de">
              <img
                  class="text-center mt-3"
                  src="../assets/images/partners/caritas_sofia.jpg"
                  width="100%"
              >
            </a>
          </p>
        </b-col>
        <b-col md="3">
          <p class="mt-2 text-center">
            <a href="https://bmbf.de">
              <img
                class="text-center mt-3"
                src="../assets/images/partners/bfi.png"
                width="100%"
              >
            </a>
          </p>
        </b-col>
        <b-col md="3">
          <p class="mt-5 text-center">
            <a href="https://bmbf.de">
              <img
                class="text-center mt-3"
                src="../assets/images/kasa_claim.svg"
                width="100%"
              >
            </a>
          </p>
        </b-col>

        <b-col md="3">
          <p class="mt-4 text-center">
            <a href="https://bmbf.de">
              <img
                  class="text-center mt-5"
                  src="../assets/images/partners/eu.jpg"
                  width="140%"
              >
            </a>
          </p>
        </b-col>
        <b-col md="3">
          <p class="mt-4 text-center">
            <a href="https://bmbf.de">
              <img
                  class="text-center mt-3"
                  src="../assets/images/partners/bmbf.jpg"
                  height="150px"
              >
            </a>
          </p>
        </b-col>
        <b-col md="3">
          <p class="text-center">
            <a href="https://bmbf.de">
              <img
                  class="text-center mt-3"
                  src="../assets/images/partners/erasmus_plus_deutschland.png"
                  width="100%"
              >
            </a>
          </p>
        </b-col>
        <b-col md="3" class="mb-5">
          <p class="text-muted text-right text-small mb-5" style="padding-top: 150px">
            &copy; GIZ gGmbH {{ year }} | <router-link to="/imprint">
              Imprint
            </router-link>
          </p>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
  export default {
    name: 'Foot',
    computed: {
      year: () => {
        return new Date().getFullYear()
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import '../style/bootstrap-component-include';

  #footer-pre {
    border-top: 1px dashed $dark;
    padding-bottom: 20px;
  }

  .text-small {
    font-size: 70%;
  }
</style>
